import { Injectable } from '@angular/core';
import { FieldAgentClient, Product2, ProductCompetitorPrice, ProductCompetitor, Per } from 'ep-bt-field-agent-proxy';
import { CompetitorPriceLine } from '../models/competitor-price-line.model';
import { QuantityType } from 'ep-bt-controls';
import { CompetitorPricing } from '../models/competitor-pricing.model';

@Injectable({
  providedIn: 'root'
})

export class EpbtFaCompetitorService {

  constructor(private client: FieldAgentClient) { }



  // This will be used when product is selected and come back to wizard

  public wizardStep = 0;

  public searchCompetitorString = '';

  // selected customer id
  public customerId: number;

  // List of selected competitor
  public selectedCompetitorItem: any;

  // List of selected competitor
  public competitorPricing: CompetitorPricing;

  //
  public competitorPricingLine: CompetitorPriceLine;

  // selected competitor
  public selectedCustomer: any;

  // selected competitor customer
  public selectedCompetitors: any[] = [];

  // List of selected competitor
  public isCompetitor = false;

  // public isReCall: boolean = false;
  competitorPriceFormFlag: boolean;

  public finalCompetitorObj: any[] = [];

  public isNegotiationEdit = false;

  public sellPricePers: Per[] = [];

  public selectedProductsForBinding: any[] = [];
  data: any;
  competitorID: number;
  productId: number;

  // selectCompetitorAddress
  public selectCompetitorAddressId: number;
  public selectCompetitorAddress: any;
  public selectCompetitorTypeId = 0;
  // List of products used for competitor Pricing
  public selectedProducts: any[] = [];



  pushDataToServiceObj(flag: boolean) {
    this.selectedProductsForBinding = [];
    this.selectedProducts.forEach(product => {
      this.selectedProductsForBinding.push({
        productCode: product.productCode,
        description: product.description
      });
    });
  }

  LoadProductPers(selectedProduct: any, subscribe: (flag: boolean) => void) {
    let product2 = new Product2();
    product2 = selectedProduct;
    product2.dateTimeLastModified = new Date();
    this.competitorID = this.customerId;
    this.productId = product2.productId;

    try {
      this.client.loadProductPers(product2).subscribe(res => {
        this.data = res;
        this.sellPricePers = this.data.sellPricePers;
        this.competitorPricingLine = new CompetitorPriceLine(this.competitorPricing, this.data, QuantityType.Per);
        if (this.selectCompetitorTypeId == 0) {
          this.client.getProductCompetitor(this.competitorID, this.productId).subscribe(res => {
            if (res) {
              const productCompetitor = res;
              this.competitorPricingLine.competitorProductCode = productCompetitor.productCode;
              this.competitorPricingLine.competitorProductDescription = productCompetitor.productDescription;
              this.competitorPricingLine.competitorSellPerID = productCompetitor.sellPerID;
              this.competitorPricingLine.competitorSellPrice = productCompetitor.sellPrice;
              this.competitorPricingLine.competitorSellPer = productCompetitor.sellPer;
              this.competitorPricingLine.dateTimelastUpdated = productCompetitor.dateTimeLastUpdated;

              const per = this.competitorPricingLine.ourProduct.sellPricePers.filter(x => x.perId == res.sellPerID);
              if (per && per.length > 0) {
                this.competitorPricingLine.competitorSellPer = per[0];
              }
              this.competitorPricingLine.notes = productCompetitor.notes;
            }
            subscribe(true);
          });

        } else {
          this.client.getProductCompetitorPrice(this.competitorID, this.productId, this.selectCompetitorAddress.addressId).subscribe(res => {
            if (res) {
              const productCompetitorPrice = res;
              this.competitorPricingLine.competitorSellPerID = productCompetitorPrice.sellPerID;
              this.competitorPricingLine.competitorSellPrice = productCompetitorPrice.sellPrice;
              this.competitorPricingLine.dateTimelastUpdated = productCompetitorPrice.dateTimeLastUpdated;
              this.competitorPricingLine.competitorProductCode = productCompetitorPrice.productCode;
              this.competitorPricingLine.competitorProductDescription = productCompetitorPrice.productDescription;
              const per = this.competitorPricingLine.ourProduct.sellPricePers.filter(x => x.perId == res.sellPerID);
              if (per && per.length > 0) {
                this.competitorPricingLine.competitorSellPer = per[0];
              }
              this.competitorPricingLine.notes = productCompetitorPrice.notes;
            }
            subscribe(true);
          });
        }
      });
    } catch (ex) {
      console.log('error:-' + ex);
    }
  }

  clearData() {
    // this.selectedCompetitors = [];
    // this.selectedCustomer= [];
    this.competitorPricing = null;
    this.customerId = null;
    this.searchCompetitorString = '';
    this.searchCompetitorString = undefined;
    this.selectCompetitorTypeId = 0;
    this.selectCompetitorAddressId = 0;
    this.competitorPricingLine = null;
    this.competitorID = null;
    this.selectCompetitorAddress = null;
    this.productId = null;
    this.data = null;
    this.competitorPriceFormFlag = false;
    this.wizardStep = 0;
  }
}
